<template>
  <div class="ly-table">
    <div class="table-header">
      <span class="table-title"
        >{{ $t("messages.titServiceRequestProcessing") }}
      </span>
    </div>
    <div class="ly-flex">
      <div class="ly-sort ly-sort-his">
        <div class="sort-count">
          <p class="table-cell-all">
            {{ $t("messages.all") }} <span class="table-cell-count">97</span
            >{{ $t("messages.unit") }}
          </p>
          <div class="sort-select">
            <el-select
              size="medium"
              v-model="count"
              :placeholder="$t('messages.plCount25')"
            >
              <el-option
                v-for="item in countList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span>
              {{ $t("messages.perShow") }}
            </span>
          </div>
        </div>
      </div>
      <div class="ly-btn">
        <el-button plain size="small" type="excel"
          >{{ $t("messages.btnExcel") }}<i class="icon-DownloadSimple"></i
        ></el-button>
      </div>
    </div>
    <div class="table-body">
      <idc-list :tableData="tableData" :tableHeader="tableHeader">
        <template #col9="{ scope }">
          <el-button type="save" size="small" @click="openWorkDetail">
            <!-- 22.03.15 작업상세화면 모달 이벤트 추가 -->
            {{ $t("messages.btnView") }}
          </el-button>
        </template>
      </idc-list>
    </div>
  </div>
</template>

<script>
import IdcList from "@/components/common/IdcList";

export default {
  props: {
    custId: {
      default: "",
    },
  },
  components: {
    IdcList,
  },
  data() {
    return {
      // 22.03.15 count, countList 추가
      count: "25개",
      countList: [
        {
          label: "25개",
          value: "10",
        },
      ],
      tableHeader: [
        {
          type: "index",
          label: "NO",
        },
        {
          prop: "col1",
          label: "메인서비스",
        },
        {
          prop: "col2",
          label: "부가서비스",
        },
        {
          prop: "col3",
          label: "SR유형",
        },
        {
          prop: "col4",
          label: "SR ID",
          width: 100,
        },
        {
          prop: "col5",
          label: "상태",
        },
        {
          prop: "col6",
          label: "접수일",
          width: 150,
        },
        {
          prop: "col7",
          label: "개통희망일",
          width: 150,
        },
        {
          prop: "col8",
          label: "완료일",
          width: 150,
        },
        {
          prop: "col9",
          label: "이력",
          columnType: "custom",
        },
      ],
      tableData: [
        {
          col1: "코로케이션",
          col2: "-",
          col3: "신규",
          col4: "S00000001",
          col5: "완료",
          col6: "2022/01/01 00:00:00",
          col7: "2022/01/01 00:00:00",
          col8: "2022/01/01 00:00:00",
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    openWorkDetail() {
      // 22.03.15 작업상세화면 모달 이벤트 추가
      this.$emit("openWorkDetail");
    },
  },
};
</script>

<style></style>
